import RoomData from './room-data';
import RoomGames from '../components/room-games';
import useReduxState from '@hooks/useReduxState';
import styles from './lobby.module.scss';

const Lobby = (): JSX.Element => {
  const [{ rooms }] = useReduxState((state) => state.blackjackLobby);

  /* Components */

  const Rooms = rooms.map((room) => (
    <div className={styles.roomItem} key={room.current_game.uid}>
      <RoomData {...{ room }} className={styles.roomItem__data} />
      <RoomGames {...{ room }} className={styles.roomItem__games} />
    </div>
  ));

  return <section className={styles.lobby}>{Rooms}</section>;
};

export default Lobby;
